import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';
import LanguageSwitcher from '../../LanguageSwitcher';

const Header = ({ userPlan, dailyRewards = 0, totalRewards = 0 }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout(); // call logout from useAuth
    navigate('/auth/login');
  };

  const userName = user?.email?.split('@')[0] || 'User';

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-100 z-50">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center">
              <i className="ri-store-line text-white text-lg"></i>
            </div>
            <div>
              <h1
                className="text-lg font-bold text-gray-900"
                style={{ fontFamily: '"Pacifico", serif' }}
              >
                dulce comercio
              </h1>
            </div>
          </div>

          {/* User Info, Language Switcher & Logout */}
          <div className="flex items-center space-x-3">
            {/* User Greeting */}
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">
                Hi, {userName}
              </p>
              {userPlan && (
                <p className="text-xs text-gray-500">
                  {dailyRewards}/{totalRewards} sales today
                </p>
              )}
            </div>

            {/* 🌍 Language Switcher */}
            <div>
              <LanguageSwitcher />
            </div>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Logout"
            >
              <i className="ri-logout-box-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
